/**
 * Spanish sentences tend to be longer than English ones (for which the recommended limit is 20 words).
 * This is why the sentence length limit was increased to 25 for Spanish. For more detailed explanation, see:
 * https://github.com/Yoast/research/wiki/Sentence-Length-Spanish
 */

export default {
	sentenceLength: {
		recommendedWordCount: 25,
	},
};
